import React from "react";

const ModalHistoryCard = ({
  title,
  description,
  venue,
  participatingClasses,
  orderedBy,
  status,
}) => {
  return (
    <tr>
      <td>
        <div className="flex-col align-start justify-start g-05">
          <span className="f-16 poppins">{title}</span>
          <span className="t-13 poppins color-grayColor">{description}</span>
        </div>
      </td>
      <td className="t-14 color-greenColor poppins text-align-center">
        {venue}
      </td>
      <td className="t-14 color-greenColor poppins text-align-center">
        {participatingClasses}
      </td>
      <td className="t-14 color-greenColor poppins text-align-center">
        {orderedBy}
      </td>
      <td className="t-14 color-greenColor poppins text-align-center">
        {status}
      </td>
    </tr>
  );
};

export default ModalHistoryCard;
